import { useMemo } from 'react'
import { searchVerticalItemsByKey } from 'constants/search'
import { useGlobalHotelsSearchContext } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalHotelsSearch'
import HotelsTabContent from '../Components/Mobile/TabContents/HotelsTabContent'
import useGlobalSearchVerticalTabBooking from './useGlobalSearchVerticalTabBooking'
import { GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'
import useQueryParams from 'hooks/useQueryParams'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'

function useGlobalSearchVerticalTabHotels(): App.GlobalSearchVerticalTabV2 {
  const queryParams = useQueryParams()
  const {
    globalHotelsSearchDispatch,
    globalHotelsSearchState,
  } = useGlobalHotelsSearchContext(GLOBAL_SEARCH_INITIAL_STATE, queryParams)

  const {
    onSearch,
    context,
  } = useGlobalSearchVerticalTabBooking({
    globalSearchDispatch: globalHotelsSearchDispatch,
    globalSearchState: globalHotelsSearchState,
  })

  return useMemo((): App.GlobalSearchVerticalTabV2 => {
    return {
      label: searchVerticalItemsByKey.get('hotels')?.label ?? 'hotels and resorts',
      key: 'hotels',
      context,
      onSearch,
      ContentComponent: HotelsTabContent,
      Icon: LineBedIcon,
    }
  }, [context, onSearch])
}

export default useGlobalSearchVerticalTabHotels
